import React from 'react';
import { IRadioField } from './interfaces';
import { FormControl, FormLabel, RadioGroup } from '@mui/material';
import { RadioOption } from '../RadioOption';

export const RadioField: React.FC<IRadioField> = ({
  label,
  required,
  error,
  value,
  options,
  onChange,
}): JSX.Element => {
  return (
    <FormControl>
      <FormLabel
        id="demo-radio-buttons-group-label"
        error={error}
        required={required}
        sx={{
          fontSize: '12px',
          textTransform: 'uppercase',
          fontWeight: 'bold',
        }}
      >
        {label}
      </FormLabel>
      <RadioGroup value={value} onChange={(e) => onChange(e.target.value)}>
        {options.map((optionProps) => {
          return <RadioOption key={optionProps.value} {...optionProps} />;
        })}
      </RadioGroup>
    </FormControl>
  );
};
